module.exports = __webpack_public_path__ + "img/icon-3.812c2afb.png";